import { Navigate } from 'react-router-dom';

import { useSession } from '../auth/session.js';
import { AsyncMessage } from '../components/async-message.js';
import { AppLayout } from './app-layout.js';

export function ProtectedLayout() {
  const session = useSession();

  if (session.isPending) {
    return <AsyncMessage kind="loading" title="Chargement de votre session…" />;
  }
  if (session.isError) {
    return <Navigate replace to="/login" />;
  }
  return <AppLayout permissions={session.data.permissions} user={session.data.user} />;
}
